// Kaydedileceği yer: assets/free-gift.js
//
// gift-wrapping.js'deki GiftWrapSelector.setGiftWrap() ile birebir aynı desen
// kullanılıyor: /cart/add.js sadece eklenen satırı döndürüyor (tam sepeti
// değil), bu yüzden sections'ı ayrıca çekilen tam cart.js gövdesine
// birleştirip öyle publish ediyoruz. Aksi halde header'daki sepet sayacı gibi
// tam cart şekli bekleyen diğer bileşenler bozulurdu.
// /cart/change.js ise (removeReward) zaten tam sepeti döndürüyor, o yüzden
// CartItems.updateQuantity / GiftWrapItem.updateGiftWrap ile aynı, tek adımlı.

if (!customElements.get('free-gift')) {
  customElements.define(
    'free-gift',
    class FreeGift extends HTMLElement {
      connectedCallback() {
        this.syncing = false;
        this.evaluate();
      }

      get rewardVariantId() {
        return this.getAttribute('data-reward-variant-id');
      }

      get qualifies() {
        return this.getAttribute('data-qualifies') === 'true';
      }

      get rewardQuantity() {
        return parseInt(this.getAttribute('data-reward-quantity'), 10) || 0;
      }

      evaluate() {
        if (this.syncing || !this.rewardVariantId) return;

        if (this.qualifies && this.rewardQuantity === 0) {
          this.addReward();
        }
        else if (!this.qualifies && this.rewardQuantity > 0) {
          this.removeReward();
        }
      }

      bundledSections() {
        const sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
        return sectionsToBundle;
      }

      addReward() {
        this.syncing = true;

        const body = JSON.stringify({
          items: [{ id: this.rewardVariantId, quantity: 1 }],
          sections: this.bundledSections()
        });

        fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig('javascript'), ...{ body } })
          .then((response) => response.json())
          .then(async (parsedState) => {
            if (parsedState.status) {
              // Hediye eklenemedi (ör. stokta kalmadı) - sessizce vazgeç,
              // bir sonraki sepet güncellemesinde tekrar denenir.
              console.error(parsedState);
              return;
            }

            const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
            cartJson.sections = parsedState.sections;

            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift', cart: cartJson });
          })
          .catch((error) => console.error(error))
          .finally(() => { this.syncing = false; });
      }

      removeReward() {
        this.syncing = true;

        const body = JSON.stringify({
          id: this.rewardVariantId,
          quantity: 0,
          sections: this.bundledSections()
        });

        fetch(theme.routes.cart_change_url, { ...theme.utils.fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((cart) => {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift', cart });
          })
          .catch((error) => console.error(error))
          .finally(() => { this.syncing = false; });
      }
    }
  );
}